import { useState } from 'react';
import { Link } from 'react-router-dom';
import RegisterModal from './RegisterModal';
import logo from '../assets/vsslogo.png'; // ✅ Import your logo
import '../styles/Navbar.css';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const openModal = () => {
    setIsModalOpen(true);
    closeMenu();
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <nav className="navbar">
        <div className="nav-container">
          {/* Logo - Only Logo Image, No Icon or Text */}
          <Link to="/" className="nav-logo" onClick={closeMenu}>
            <img src={logo} alt="VernaEvents" className="nav-logo-img" />
          </Link>

          {/* Navigation Links */}
          <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
            <li className="nav-item">
              <Link to="/" className="nav-link" onClick={closeMenu}>
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/events" className="nav-link" onClick={closeMenu}>
                Events
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/about" className="nav-link" onClick={closeMenu}>
                About
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/contact" className="nav-link" onClick={closeMenu}>
                Contact
              </Link>
            </li>
            <li className="nav-item nav-item-cta">
              <button className="nav-cta-btn" onClick={openModal}>
                🎯 Register Team Now
              </button>
            </li>
          </ul>

          {/* Mobile Menu Button */}
          <div className={`nav-toggle ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>
        </div>
      </nav>

      {/* Register Modal */}
      <RegisterModal isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
}

export default Navbar;